import TermAddForm from './TermAddForm';

export default TermAddForm;
